import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import { Fragment } from 'react'

type Props = {
  isOpen: boolean
  message: string
  variant?: 'success' | 'error'
  topMost?: boolean
}

export const Alert = ({
  isOpen,
  message,
  variant = 'error',
  topMost = false,
}: Props) => {
  const classes = classNames(
    // One neutral toast for every message, inverted against the page (dark on
    // light, light on dark), like the board's own feedback. Success reads
    // slightly larger so the win lands.
    'fixed z-30 top-14 left-1/2 -translate-x-1/2 max-w-[90vw] rounded-lg bg-gray-900 text-white shadow-xl pointer-events-auto dark:bg-white dark:text-gray-900',
    {
      'px-4 py-2.5 text-sm font-bold': variant === 'error',
      'px-5 py-3 text-base font-extrabold tracking-tight':
        variant === 'success',
    }
  )

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="ease-out duration-300 transition"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className={classes}>
        <p className="text-center" role="status">
          {message}
        </p>
      </div>
    </Transition>
  )
}
